/**
 * Avatar placeholder initials: "FL" for first + last name, "F" for first name
 * only. Falls back to the last name, then the email, so a placeholder still
 * shows something meaningful; returns null when nothing usable is known.
 */
export function getUserInitials(
  firstName: string | null | undefined,
  lastName: string | null | undefined,
  email?: string | null
): string | null {
  const first = firstInitial(firstName)
  const last = firstInitial(lastName)

  if (first || last) return `${first}${last}`
  return firstInitial(email) || null
}

function firstInitial(value: string | null | undefined): string {
  const [char = ''] = Array.from(value?.trim() ?? '')
  return char.toLocaleUpperCase()
}
